import React from "react";
import DocumentTitle from "react-document-title";
import PropTypes from "prop-types";

const PageTitle = props => (
  <DocumentTitle title={!props.title ? "Connected Buildings" : props.title}>
    {props.children}
  </DocumentTitle>
);

PageTitle.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string
};

export default PageTitle;
